/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: calc(5.1428571429rem);
  min-height: calc(5.1428571429rem);
  z-index: 100;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
}
:host .left,
:host .right,
:host .right .app-name {
  display: flex;
  align-items: center;
  height: calc(5.1428571429rem);
}
:host .left .pane-toggle {
  margin-left: calc(1.4285714286rem);
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host .left .pane-toggle:hover {
  cursor: pointer;
}
:host .left .pane-toggle:hover, :host .left .pane-toggle.selected {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
:host .left .logo {
  margin-left: calc(1.4285714286rem);
  display: flex;
}
:host .left .logo .sick-svg-logo {
  height: calc(1.5714285714rem);
}
:host .left .logo.custom {
  height: auto;
  width: auto;
  max-height: calc(2.8571428571rem);
  max-width: calc(14.2857142857rem);
}
:host .right .app-name {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  font-size: calc(1.4285714286rem);
  margin-right: calc(1.7142857143rem);
}
:host .right .app-name.hidden {
  visibility: hidden;
  overflow-wrap: anywhere;
  height: 0;
  overflow: hidden;
}
:host ::slotted(hr),
:host hr {
  box-sizing: border-box;
  display: inline-block;
  margin-left: calc(0.8571428571rem);
  margin-right: calc(1.7142857143rem);
  width: 0;
  min-height: calc(1.7142857143rem);
  border: none;
  border-right: calc(0.1428571429rem) solid;
  border-color: #737F85;
  border-color: var(--davinci-color-text-lighter, #737F85);
}
:host hr {
  margin-left: calc(1.7142857143rem);
  margin-right: 0;
}
:host ::slotted(davinci-flyout-menu) {
  margin-right: calc(0.8571428571rem);
}
:host slot[name=left]::slotted(davinci-core-header-button) {
  margin-left: calc(1.4285714286rem);
  margin-right: 0;
}`;
export { style };
